/* Sleepsake — mural de avaliações nativo (desenho do widget da loja de origem, sem o app).
   Lê o acervo do <script data-sk-avaliacoes-dados>, monta o mosaico, carrega mais, ordena, filtra por nota
   e abre a avaliação inteira num popup. */
(function () {
  const POR_PAGINA = 20;

  const escapa = (t) =>
    String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const estrelas = (nota) =>
    `<span role="img" aria-label="Rating icons: ${nota} / 5 star review" style="display: inline-flex; margin: unset; padding: unset; text-indent: unset; list-style-type: none; gap: 2px;">` +
    [1, 2, 3, 4, 5]
      .map(
        (i) =>
          `<svg class="loox-icon star" data-lx-fill="${i <= nota ? 'full' : 'empty'}" aria-hidden="true" role="presentation" style="display: block; width: 1em; height: 1em;" viewBox="0 0 24 24"><use href="#looxicons-rating-icon"></use></svg>`
      )
      .join('') +
    `</span>`;

  const selo =
    `<span class="verified-badge-and-text" style="display: flex; align-items: center; gap: 4px"><svg class="loox-icon loox-verified-badge" role="img" aria-label="Verified purchase" style="width: 14px; height: 14px; vertical-align: middle; flex-shrink: 0; overflow: visible;" viewBox="0 0 24 24"><use href="#loox-ic-verified-icon"></use></svg><span style="font-style: normal; font-weight: 400; font-size: 12px; line-height: 18px; white-space: nowrap;">Verified</span></span>`;

  function cartao(r, produto) {
    const temFoto = (r.fotos || []).length > 0;
    const foto = temFoto
      ? `<div class="item-img box" style="position:relative;"><div class="image-aspect-ratio-wrapper"><div class="image-aspect-ratio" style="padding-bottom: ${(r.proporcao || 1) * 100}%;"></div><img class="action" alt="Customer photo review of ${escapa(produto)}" data-img-ratio="${r.proporcao}" src="${r.fotos[0]}&width=600" loading="lazy" style="background:${r.cor || '#eee'};"></div>${
          r.fotos.length > 1 ? `<span class="multi-photo-badge"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20"><path d="m3.122 11.13 1.455-1.455 4.002 4.002 2.547-2.547 2.183 2.183V6.69H3.122v4.439Zm-.728-5.894h11.642a.727.727 0 0 1 .728.728v11.642a.727.727 0 0 1-.728.727H2.394a.727.727 0 0 1-.727-.727V5.964a.728.728 0 0 1 .727-.728Zm8.368 5.093a1.091 1.091 0 1 1 0-2.182 1.091 1.091 0 0 1 0 2.182Z"></path><path d="m15.492 9.364 1.17 1.43.658-6.59L7.184 3.192l-.132 1.317H5.59l.219-2.186a.728.728 0 0 1 .796-.652l11.584 1.16a.728.728 0 0 1 .652.796L17.682 15.21a.728.728 0 0 1-.796.651l-1.394-.139V9.364Z"></path></svg>+${r.fotos.length - 1}</span>` : ''
        }</div>`
      : '';
    return `<div class="grid-item-wrap ${temFoto ? 'has-img' : 'no-img'}" data-id="${escapa(r.id)}" data-media-type="${temFoto ? 'photo' : 'none'}"><div class="grid-item clearfix" role="button" tabindex="0">${foto}<div class="main action"><div class="box${r.aparado ? ' trimmed-text' : ''}"><div class="block title">${escapa(r.nome)}${r.verificado ? selo : ''}</div><div class="clearfix"></div><div class="block time" data-time="${r.data}"></div><div class="block stars">${estrelas(r.nota)}</div><div class="block"><div class="pre-wrap main-text">${r.curto_html || escapa(r.texto)}</div></div></div></div></div></div>`;
  }

  function datas(raiz) {
    raiz.querySelectorAll('.block.time[data-time]').forEach((el) => {
      if (el.textContent.trim()) return;
      const t = Number(el.dataset.time);
      if (t) el.textContent = new Date(t).toLocaleDateString();
    });
  }

  function iniciar(raiz) {
    const fonte = raiz.querySelector('[data-sk-avaliacoes-dados]');
    if (!fonte) return;
    let dados;
    try {
      dados = JSON.parse(fonte.textContent);
    } catch (e) {
      return;
    }
    const todas = dados.avaliacoes || [];
    const produto = raiz.dataset.produto || '';
    const grade = raiz.querySelector('#grid');
    const mais = raiz.querySelector('[data-sk-mais]');
    const popup = raiz.querySelector('[data-sk-popup]');
    let lista = todas.slice();
    let mostradas = Math.min(POR_PAGINA, lista.length);
    let mosaico = null;

    const montarMosaico = () => {
      if (!window.Masonry || !grade) return;
      if (mosaico) mosaico.destroy();
      mosaico = new window.Masonry(grade, { itemSelector: '.grid-item-wrap', originLeft: true });
      grade.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => mosaico && mosaico.layout(), { once: true });
      });
    };
    const quandoMasonry = (fn) => (window.Masonry ? fn() : window.addEventListener('load', fn, { once: true }));

    const renderizar = (inicio) => {
      const html = lista.slice(inicio, mostradas).map((r) => cartao(r, produto)).join('');
      if (inicio === 0) grade.innerHTML = html; // idempotente: nada se soma ao que o servidor já desenhou
      else grade.insertAdjacentHTML('beforeend', html);
      datas(grade);
      if (mais) mais.parentElement.hidden = mostradas >= lista.length;
      quandoMasonry(montarMosaico);
    };

    datas(grade);
    quandoMasonry(montarMosaico);
    // escrever avaliação: sem o app, o pedido vai para o atendimento da loja
    raiz.querySelectorAll('[data-testid="write-review-button"], #write, #bethefirst').forEach((b) =>
      b.addEventListener('click', () => (window.location.href = '/pages/contact-us'))
    );

    mais?.addEventListener('click', () => {
      const inicio = mostradas;
      mostradas = Math.min(mostradas + POR_PAGINA, lista.length);
      renderizar(inicio);
    });

    // ordenação (menu do cabeçalho)
    const menu = raiz.querySelector('ul.loox-dropdown');
    raiz.querySelector('.menu-icon')?.addEventListener('click', (e) => {
      e.stopPropagation();
      if (menu) menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
    });
    raiz.querySelectorAll('ul.loox-dropdown button[data-sort]').forEach((b) =>
      b.addEventListener('click', () => {
        const modo = b.dataset.sort;
        lista = (filtro ? todas.filter((r) => r.nota === filtro) : todas.slice()).sort((a, c) =>
          modo === 'newest' ? c.data - a.data : modo === 'highest_ratings' ? c.nota - a.nota : modo === 'lowest_ratings' ? a.nota - c.nota : 0
        );
        mostradas = Math.min(POR_PAGINA, lista.length);
        renderizar(0);
        if (menu) menu.style.display = 'none';
      })
    );

    // distribuição por nota e filtro
    let filtro = null;
    const dist = raiz.querySelector('.reviews-dist');
    const resumo = raiz.querySelector('.summary-content');
    resumo?.addEventListener('click', (e) => {
      e.stopPropagation();
      const aberto = dist && dist.style.display === 'block';
      if (dist) dist.style.display = aberto ? 'none' : 'block';
      resumo.setAttribute('aria-expanded', String(!aberto));
      raiz.querySelectorAll('.header-chevron > *').forEach((c) => c.classList.toggle('chevron-hide'));
    });
    raiz.querySelectorAll('.rating-dist-row[data-sk-filtro]').forEach((linha) => {
      const aplicar = () => {
        const nota = Number(linha.dataset.skFiltro);
        filtro = filtro === nota ? null : nota;
        raiz.querySelectorAll('.rating-dist-row').forEach((l) => l.classList.toggle('rating-filter-selected', Number(l.dataset.skFiltro) === filtro));
        lista = filtro ? todas.filter((r) => r.nota === filtro) : todas.slice();
        mostradas = Math.min(POR_PAGINA, lista.length);
        renderizar(0);
      };
      linha.addEventListener('click', aplicar);
      linha.addEventListener('keydown', (e) => e.key === 'Enter' && aplicar());
    });
    document.addEventListener('click', (e) => {
      if (menu && !e.target.closest('nav.menu')) menu.style.display = 'none';
      if (dist && !e.target.closest('.reviews-dist') && !e.target.closest('.summary-content')) dist.style.display = 'none';
    });

    // avaliação inteira no popup
    const abrir = (id) => {
      const r = todas.find((x) => x.id === id);
      if (!r || !popup) return;
      const fotos = (r.fotos || []).map((u) => `<img src="${u}&width=1200" alt="Customer photo review" loading="lazy">`).join('');
      popup.innerHTML = `<div class="sk-avaliacoes__popup-corpo${fotos ? ' sk-avaliacoes__popup-corpo--fotos' : ''}"><button class="sk-avaliacoes__fechar" aria-label="Close" data-sk-fechar>&times;</button>${
        fotos ? `<div class="sk-avaliacoes__popup-fotos">${fotos}</div>` : ''
      }<div class="sk-avaliacoes__popup-texto"><div class="block title">${escapa(r.nome)}${r.verificado ? selo : ''}</div><div class="block stars">${estrelas(r.nota)}</div><div class="block time" data-time="${r.data}"></div><div class="pre-wrap main-text">${escapa(r.texto)}</div></div></div>`;
      datas(popup);
      popup.showModal();
    };
    grade.addEventListener('click', (e) => {
      const item = e.target.closest('.grid-item-wrap');
      if (item) abrir(item.dataset.id);
    });
    grade.addEventListener('keydown', (e) => {
      const item = e.target.closest('.grid-item-wrap');
      if (item && e.key === 'Enter') abrir(item.dataset.id);
    });
    popup?.addEventListener('click', (e) => {
      if (e.target === popup || e.target.closest('[data-sk-fechar]')) popup.close();
    });
  }

  const tudo = () => document.querySelectorAll('[data-sk-avaliacoes]').forEach(iniciar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo);
  else tudo();
})();
